package com.example.borshi.web.orders

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.cursor
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun OrderConfirmationScreen(orderId: String? = null, onGoHome: () -> Unit, onViewOrders: (() -> Unit)? = null) {
    Div({
        style {
            height(80.vh)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            textAlign("center")
            padding(20.px)
        }
    }) {
        Div({
            style {
                fontSize(80.px)
                marginBottom(24.px)
            }
        }) {
            Text("🎉")
        }

        H1({ style { fontSize(32.px); marginBottom(16.px); color(Color("#D11243")) } }) {
            Text("Order Placed Successfully!")
        }

        P({ style { fontSize(18.px); color(Color("#757575")); marginBottom(32.px) } }) {
            Text("Thank you for choosing Borshi properly. We will contact you shortly to confirm delivery." + (orderId?.let { " Order ID: $it" } ?: ""))
        }

        Div({
            style {
                display(DisplayStyle.Flex)
                property("gap", "12px")
            }
        }) {
            Button({
                style {
                    backgroundColor(Color("#D11243"))
                    color(Color.white)
                    padding(12.px, 24.px)
                    borderRadius(25.px)
                    border(0.px)
                    cursor("pointer")
                    fontSize(16.px)
                    fontWeight("bold")
                }
                onClick { onGoHome() }
            }) {
                Text("Back to Home")
            }

            if (onViewOrders != null) {
                Button({
                    style {
                        backgroundColor(Color("#26A69A"))
                        color(Color.white)
                        padding(12.px, 24.px)
                        borderRadius(25.px)
                        border(0.px)
                        cursor("pointer")
                        fontSize(16.px)
                        fontWeight("bold")
                    }
                    onClick { onViewOrders() }
                }) {
                    Text("View Orders")
                }
            }
        }
    }
}
